export function useBehaviour({ onSearch }: Props) {
  return {
    onSearch,
  };
}

export type Props = {
  onSearch: (search: string) => void,
}
